import React from "react";

const Footer = () => (
	<div className="footer">
	  <div class="footer-grid">
		<section>
		    <br />
			<h1 style={{color:'white'}}>Retrosynthesis AI</h1>
			<p style={{color:'white'}}><strong> </strong> <br />
			 <br />
			 </p>
		
			<p style={{color:'white'}} > Platform Version 22.8.15</p>
			<p style={{color:'white'}} > Copyright &copy; 2022 Retrosynthesis AI </p>
	   	</section>
	
	        <section className="links_footer">
		   <p className="links_subtitle_footer"><a href="https://retrosynthesis-ai.gitbook.io/retrosynthesis-ai/">Documentation</a></p>
			<p className="links_subtitle_footer"><a href="Drugs.html">Classifications</a></p>
			<p className="links_subtitle_footer"><a href="https://share.streamlit.io/retrosynthesisai/explore_app/main#visualization">Explore</a></p>
			<p className="links_subtitle_footer"><a href="FAQ.html">FAQs</a></p>
			<p className="links_subtitle_footer"><a href="resources.html">Resources</a></p>
			<p className="links_subtitle_footer"><a href="Contact.html">Contact</a></p>
	        </section>
		<section className="links_footer">
	               <p className="links_subtitle_footer"><b> </b></p> 
			<a href="https://twitter.com/Retrosynth_AI"><img src="/images/Twitter.jpeg" alt="twitter" /></a><br />
			<a href="https://github.com/RetrosynthesisAI"><img src="/images/GitHub.jpeg" alt="github" /></a><br />
			<a href="https://www.youtube.com/channel/UCbTzL6sldDrmxRJTjgY95dA"><img src="/images/YouTube.png" alt="youtube" /></a>
	        </section>
	
	</div>
	</div>
);

export default Footer;
